import React, { useEffect, useMemo, useRef } from 'react'
import { t } from 'i18next';
import { StyledListItemText } from '../../../../TreeList/treeList'
import { PenIcon } from '../../../../Icons/PenIcon'
import { DeleteIcon } from '../../../../Icons/DeleteIcon'
import MoreOptionsButton from '../../../../Buttons/MoreOptionsButton';
import { getLanguageValue } from '../../../../../utils/getLanguageValue';
import { useDNDTree } from '../../../../../utils/hooks/useDNDTree';
import { MdLibraryAdd } from 'react-icons/md'
import { emptyGuid } from '../../../../../utils/emptyGuid';
import { StyledContextMenu } from '../../../../ContextMenu/StyledContextMenu';
import { ContextMenuTrigger } from 'react-contextmenu';
import PortalContextMenu from '../../../../ContextMenu/PortalContextMenu';
import MediaQuery from 'react-responsive';
import { StyledItemWrapperDND, renderTemplateArrow } from '../../../../TreeList/dndTreeList'

const SizeSystemItem = ({
  arrayItem,
  index,
  moveCardHandler,
  changeOpenProp,
  editSize,
  addSize,
  deleteSize
}) => {

  const isSystem = arrayItem.type === "system"
  const isSize = arrayItem.type === "size"

  const canDrop = (item) => {
    let sameSizeOrSystem = !!item && item.sizeId === arrayItem.sizeId && item.systemId === arrayItem.systemId && item.type === arrayItem.type
    if (sameSizeOrSystem) {
      return true
    }
    return false
  }

  const { isOver, isDragging, drag, drop, item } = useDNDTree({ index, ...arrayItem }, moveCardHandler, canDrop)
  const ref = useRef(null)

  const itemName = useMemo(() => {
    if (isSystem) {
      return getLanguageValue(arrayItem.internalName.values)
    }
    if (isSize) {
      return getLanguageValue(arrayItem.name.values)
    }
    return <span>{"???"}</span>
  }, [arrayItem, isSize, isSystem])

  const opacity = isDragging ? "0.2" : "1";

  const options = [
    (isSystem) ? {
      option: 'add',
      optionText: t('sizeAdmin:addSize'),
      optionIcon: <MdLibraryAdd />,
      onOptionSelect: () => addSize({ systemId: arrayItem.id })
    } : null,
    (isSize && arrayItem.id !== emptyGuid) ? {
      option: 'edit',
      optionText: t('edit'),
      optionIcon: <PenIcon />,
      onOptionSelect: () => editSize({ systemId: arrayItem.systemId, sizeId: arrayItem.id })
    } : null,
    (isSize && arrayItem.id !== emptyGuid) ? {
      option: 'delete',
      optionText: t('deleteButton'),
      optionIcon: <DeleteIcon />,
      onOptionSelect: () => deleteSize({ systemId: arrayItem.systemId, sizeId: arrayItem.id })
    } : null,
  ]

  //open arrayItem automatically if drag mouse isOver
  useEffect(() => {
    let timerRef = null
    const handleStateChange = () => {
      timerRef = setTimeout(() => {
        changeOpenProp(arrayItem.id)
      }, 1000);
    };
    isOver && !timerRef && isSystem && handleStateChange();
    return () => {
      clearTimeout(timerRef);
    };
  }, [isOver, changeOpenProp, isSystem, arrayItem.id]);

  drag(drop(ref))
  let sameSizeOrSystem = !!item && item.sizeId === arrayItem.sizeId && item.systemId === arrayItem.systemId && item.type === arrayItem.type

  return (
    <StyledContextMenu>
      <ContextMenuTrigger id={`${arrayItem.id}_${arrayItem.systemId}`} holdToDisplay={-1}>
        <StyledItemWrapperDND
          ref={ref}
          id={`${index}_id`}
          style={{ opacity }}
          isClickable
          showTopLine={isOver && sameSizeOrSystem && item.index > index}
          showBottomLine={isOver && sameSizeOrSystem && item.index < index}
          hierarchyLevel={isSystem ? 0 : isSize ? 1 : 2}
          onContextMenu={e => e.preventDefault()}
        >
          {isSystem ? renderTemplateArrow(arrayItem.open, arrayItem.sizesLoaded, () => changeOpenProp(arrayItem.id)) : null}
          <StyledListItemText title={null}>
            {itemName}
          </StyledListItemText>
          <MediaQuery maxWidth={1499}>
            <div className="action-buttons">
              <MoreOptionsButton options={options} />
            </div>
          </MediaQuery>
        </StyledItemWrapperDND>
      </ContextMenuTrigger>
      <PortalContextMenu contextId={`${arrayItem.id}_${arrayItem.systemId}`} options={options} />
    </StyledContextMenu>
  )
}

export default SizeSystemItem